import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  bodyWrapper: {
    height: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  logoWrapper: {
    width: '100%',
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    display: 'block',
    width: '40%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  subtitle: {
    minHeight: '3rem',
    paddingTop: '1em',
  },
  languageChoiceWrapper: {
    width: '100%',
    flexGrow: 1,
  },
  iconFlags: {
    fontSize: '1.25rem',
    width: '1rem',
    height: '1rem',
  },
  continueButton: {
    marginBottom: theme.spacing(2),
  },
  pickupText: {
    marginTop: '2rem',
  },
  primaryText: {
    fontSize: '1.3rem',
    marginBottom: '1rem',
  },
  secondaryText: {
    fontSize: '.7rem',
    color:"rgba(0, 0, 0,0.54)"
  
  },

  logoRadius: {
    padding: '.4rem',

    backgroundColor: '#e0e0e0',
    position: 'relative',
    zIndex: '-1',
    borderRadius: '50px 50px',
    width:"64px",
    height:"64px",
    display:"flex",
    alignItems:"center",
    justifyContent:"center"
  },
  pickupLogo: {
    padding: '.9rem',
    marginTop: '1rem',
  },
  timeContiner: {
    marginTop: '2.5rem',
  },
  timeInput: {
    maxWidth: '18rem',
    minWidth: '15rem',
    height: '1rem',
    fontSize: '4rem',
  },
  message:{
    marginTop:"2rem",
    textAlign:"center"
  }
}));

export default useStyles;
